import { Module } from 'wrapper6'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class Employees extends Module {
  ready (app) {
    /********************************************
	 * SHARED VARS
	 ********************************************/
    const LOADER = $('#loader')

    /********************************************
	 *
	 * EMPLOYEES FILTER SLIDER
	 *
	 ********************************************/

    // Consts
    const EMPLOYEES_TOGGLE = $('#filter-employees .cat')
    const EMPLOYEES_DEST = $('#employees-destination')

    // Lets
    let employee_cat = $('#filter-employees .cat.active').attr('data-catid')

    // Click on filter toggle
    EMPLOYEES_TOGGLE.on('click', function () {
      // Update category-id and reset pagenumber
      employee_cat = $(this).attr('data-catid')

      // Run ajax request
      getEmployees()
    })

    // Ajax request function
    function getEmployees () {
      // Show loader
      LOADER.addClass('show')

      // Set ajax data
      const data = {
        action: 'filter_employees',
        cat: employee_cat,
        url: window.location.href
      }

      // Ajax call
      jQuery.post(main_theme_objects.ajax_url, data, function (response) {
        if (response != 0) {
          // Set toggle to active, remove from siblings
          $('#filter-employees .cat[data-catid=' + employee_cat + ']').addClass('active').siblings().removeClass('active')

          // Post response
          EMPLOYEES_DEST.html(response.employees)

		  new ObjectFitClass()

          // Hide loader
          LOADER.removeClass('show')
        }
      })
    }
  }
}
